import { ThemeEvents } from "@theme/events";

// Function to update the free shipping bar
function initFreeShippingBar() {
  const bar = document.querySelector("free-shipping-bar");
  if (!bar || !(bar instanceof HTMLElement)) return;

  /* ----------------------------------
   * Language detection
   * ---------------------------------- */
  const isEnglish = window.location.pathname.startsWith("/en");

  const translations = {
    fr: {
      success: "🎉 La livraison est gratuite !",
      remainingLabel: "Encore",
    },
    en: {
      success: "🎉 Free shipping unlocked!",
      remainingLabel: "Only",
    },
  };

  const t = isEnglish ? translations.en : translations.fr;

  /* ----------------------------------
   * Config & elements
   * ---------------------------------- */
  const threshold = parseFloat(bar.dataset.threshold || "0"); // in cents
  const progressFill = bar.querySelector('[ref="progressFill"]');
  const remainingWrap = bar.querySelector(".free-shipping-remaining-wrap");
  const freeHeading = bar.querySelector("#free-shipping-heading");

  /**
   * Formats cents to a decimal string
   * @param {number} cents
   * @returns {string}
   */
  function formatCents(cents) {
    const value = cents / 100;
    return value.toFixed(2);
  }

  function updateBar() {
    // Re-query in case bar is re-rendered
    const updatedBar = document.querySelector("free-shipping-bar");
    if (!updatedBar || !(updatedBar instanceof HTMLElement)) return;

    const currentProgressFill = updatedBar.querySelector('[ref="progressFill"]');
    const currentRemainingWrap = updatedBar.querySelector(
      ".free-shipping-remaining-wrap"
    );
    const currentFreeHeading = updatedBar.querySelector(
      "#free-shipping-heading"
    );

    if (!currentProgressFill || !currentRemainingWrap) return;

    const rawCartTotal = updatedBar.getAttribute("data-cart-total");
    const cartTotal = parseInt(rawCartTotal || "0", 10) || 0;
    const remaining = threshold - cartTotal;
    const progress = Math.min(100, (cartTotal / threshold) * 100);

    currentProgressFill.style.width = `${progress}%`;

    if (remaining <= 0) {
      currentRemainingWrap.innerHTML = `
        <span class="free-shipping-success">${t.success}</span>
      `;
      if (currentFreeHeading) {
        currentFreeHeading.classList.add("hidden");
      }
    } else {
      const remainingFormatted = formatCents(remaining);
      if (currentFreeHeading) {
        currentFreeHeading.classList.remove("hidden");
      }
      currentRemainingWrap.innerHTML = `
        <span class="free-shipping-remaining-amount">${t.remainingLabel}</span>
        <span class="free-shipping-remaining-amount">${remainingFormatted}</span>
      `;
    }
  }

  // Initial update
  updateBar();

  /* ----------------------------------
   * Event listeners
   * ---------------------------------- */
  const handleCartUpdate = () => {
    setTimeout(updateBar, 0);
  };

  document.addEventListener(ThemeEvents.cartUpdate, handleCartUpdate);
  document.addEventListener(ThemeEvents.discountUpdate, handleCartUpdate);

  document.addEventListener(
    "dialog:open",
    (event) => {
      const cartDrawer = event.target;
      if (
        cartDrawer &&
        cartDrawer instanceof HTMLElement &&
        cartDrawer.classList.contains("cart-drawer")
      ) {
        setTimeout(updateBar, 50);
      }
    },
    true
  );

  const cartDrawerComponent = document.querySelector("cart-drawer-component");
  if (cartDrawerComponent) {
    cartDrawerComponent.addEventListener("dialog:open", () => {
      setTimeout(updateBar, 50);
    });
  }
}

/* ----------------------------------
 * Init
 * ---------------------------------- */
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFreeShippingBar);
} else {
  initFreeShippingBar();
}
